import type { Member as OCCMember } from '@vista-digital/ocapi-types/v1'
import { getMember, isMemberSignedIn, loadMember } from '@vista-digital/occ-domain'
import { reaction } from 'mobx'
import { useEffect, useState } from 'react'

export const useGetMember = () => {
    const occMember = getMember() ?? ({} as OCCMember)
    const [member, setMember] = useState<Member>({ ...occMember, isSignedIn: isMemberSignedIn() })

    useEffect(() => {
        const disposer = reaction(
            () => isMemberSignedIn(),
            isSignedIn => {
                setMember(s => ({ ...s, isSignedIn }))

                void (async () => {
                    if (!isSignedIn) return

                    const memberData = getMember() ?? (await loadMember())
                    setMember(s => ({ ...s, ...memberData, isSignedIn }))
                })()
            },
            { fireImmediately: true }
        )

        return () => disposer()
    }, [])

    return member
}

interface Member extends OCCMember {
    isSignedIn: boolean
}